import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import React from 'react';
import { Icons } from '../icons/icons.esm.js';
import { LinkBase } from './link-base/link-base.esm.js';

const Selectable = /*#__PURE__*/ React.forwardRef(({ children, className, dark, size, selected, selectedIcon, defaultIcon, iconSize = 'inherit', onSelect, onClick, eventKey, withHoverBg = true, ...rest }, ref)=>{
    const StateIcon = Icons?.[`${selected ? selectedIcon : defaultIcon}`];
    return jsxs(LinkBase, {
        ref: ref,
        variant: "selectable",
        target: "_self",
        className: classNames(className, {
            'link-selectable-dark': dark,
            'link-selectable-selected': selected
        }),
        onClick: (event)=>{
            onSelect?.(eventKey);
            onClick?.(event);
        },
        /**
         * Disable the default hover background if the component
         * is dark or the user has explicitly disabled it otherwise
         * the dark themed background will not be visible.
         */ withHoverBg: !dark && withHoverBg,
        size: size,
        ...rest,
        children: [
            children,
            StateIcon && jsx(StateIcon, {
                size: iconSize
            })
        ]
    });
});

export { Selectable };
